import React, { useEffect } from 'react'
import { isMobileOnly } from 'react-device-detect'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'
import { loadAnalytics, trackAnalyticsEvent } from '../../Libs/analytics'
import { isDesktop, isTablet } from '../../Libs/detect-device'

interface Props {
  analyticsId: string
  analyticsUrl: string
  basePageUrl: string
  webViewParameter?: string
}

const WEBVIEW_TABLET_EVENT_NAME = 'Webview Tablet Device Usage'
const WEBVIEW_MOBILE_EVENT_NAME = 'Webview Mobile Device Usage'
const MOBILE_EVENT_NAME = 'Mobile Device Usage'
const TABLET_EVENT_NAME = 'Tablet Device Usage'
const DESKTOP_EVENT_NAME = 'Desktop Device Usage'

/**
 * This component provides a script injection for a frontend sided analytics.
 * @param props - analyticsId - id for the specific app analytics, analyticsUrl - page of the analytics script source
 */
const PageAnalytics: React.FC<Props> = ({ analyticsId, analyticsUrl, basePageUrl, webViewParameter }) => {
  const location = useLocation()
  useEffect(() => {
    loadAnalytics(analyticsId, {
      auto: true,
      url: analyticsUrl,
    })

    if (webViewParameter) {
      if (navigator.userAgent.includes(webViewParameter)) {
        if (isTablet) {
          trackAnalyticsEvent(WEBVIEW_TABLET_EVENT_NAME)
        } else {
          trackAnalyticsEvent(WEBVIEW_MOBILE_EVENT_NAME)
        }
      } else if (isMobileOnly) {
        trackAnalyticsEvent(MOBILE_EVENT_NAME)
      } else if (isTablet) {
        trackAnalyticsEvent(TABLET_EVENT_NAME)
      } else if (isDesktop) {
        trackAnalyticsEvent(DESKTOP_EVENT_NAME)
      }
    }
  }, [analyticsId, analyticsUrl, webViewParameter])

  /**
   * TODO: Implement something more reliable than just replacing numerical path parts with :id.
   * Maybe even use the original route paths, that still have their param placeholders in them.
   * Clean the url of ids for the canonical
   */
  const cleanedPath = location.pathname
    .split('/')
    .map(v => (/^\d+$/.test(v) ? ':id' : v))
    .join('/')

  return (
    <Helmet>
      <link rel="canonical" href={basePageUrl + cleanedPath} />
    </Helmet>
  )
}

export default PageAnalytics
